// store.js

import { configureStore } from '@reduxjs/toolkit';
import convocationReducer from './convocationSlice';
import userReducer from './userSlice';
import facultyUser from './facultySlice';
import searchReducer from './headerSlice';
import staffuser from './staffSlice';
import postdocuser from './postdocSlice';
import statecsc from './isStafforFaculty';

const store = configureStore({
    reducer: {
        convocation: convocationReducer,
        user: userReducer,
        facultyuser: facultyUser,
        search: searchReducer,
        staffuser: staffuser,
        postdocuser: postdocuser,
        statecsc: statecsc,
    }
});

export default store;
